<ng-container *ngIf="navigationItems && initialized">

    <div class="mt-5">

        @if (activeNavigationItem?.action == 'bankTransactionDomain') {
            <bm-bank-transaction-domain-details [bankTransactionDomainId]="objectIdentifier.objectId"></bm-bank-transaction-domain-details>
        }

        @if (activeNavigationItem?.action == 'bankTransactionFamily') {
            <p>Banktransaktionsfamilien</p>
        }

        @if (activeNavigationItem?.action == 'bankTransactionSubFamily') {
            <p>Banktransaktionssubfamilien</p>
        }
    </div>

</ng-container>
